import { IConnections } from "../interfaces/Connections";
import { getContainerWithId, getShapeWithNodeId } from "./ContainerUtils";
import { DBItem, Record } from "../interfaces/Record";
import { AbstractShape } from "../abstract/Shape";
import { IContainer } from "../interfaces/Container";

export function extractRelations(relations: DBItem[], masterItems: AbstractShape[]){
    let relList: IConnections[] = [];
    if (relations) {
        for (const rel of relations) {
            let startItem = getShapeWithNodeId(rel.startNodeElementId, masterItems);
            let endItem = getShapeWithNodeId(rel.endNodeElementId, masterItems);
            let endChildren = endItem!.children.some((child: AbstractShape) => startItem!.dbData.elementId === child.dbData.elementId);
            if (endChildren || !endItem) continue;
            relList = [...relList, { from: startItem!.id, to: endItem!.id, type: rel.type, lineColor: "#000", relation: rel.elementId } as IConnections];
        }
    }
    return relList;
}

export function createRelations(relations: DBItem[], masterItems: AbstractShape[]){
    let relList: IConnections[] = [];
    if (relations) {
        for (const rel of relations) {
            let startItem = getShapeWithNodeId(rel.startNodeElementId, masterItems);
            let endItem = getShapeWithNodeId(rel.endNodeElementId, masterItems);
            let endChildren = endItem!.children.some((child: AbstractShape) => startItem!.dbData.elementId === child.dbData.elementId);
            if (endChildren) continue;
            if (!startItem || !endItem) continue;
            relList = [...relList, { from: startItem!.id, to: endItem!.id, type: rel.type, lineColor: "#000", relation: rel.elementId } as IConnections];
        }
    }
    return relList;
}

export function extractElements(records: Record[]){
    let elements: any[] = [];
    for (const record of records) {
        for (const key of record.keys) {
            let element = record.fields[key];
            if (!element) continue;
            if (typeof (element) === "string") continue;
            if(!Array.isArray(element)){
                element.label = key;
                element.isUsed = false;
            }
            elements = [...elements, element];
        }
    }
    return elements;
}

export function assignIncomingNodes(nodes: DBItem[], list: AbstractShape[], json: IContainer[]) {
    for (const item of list) {
        let container = getContainerWithId(item.id, json);
        if (!container) continue;
        let node = nodes.find(n => n.properties.__EDT_UUID__ === container!.dbId);
        if (!node) {
            item.name = "Node not found in DB"
            item.dbPropierties = { position_holder: "no founded"};
            continue;
        }
        item.setDBData(node);
        // item.setLabels(node.labels);
        node.isUsed = true;
        assignIncomingNodes(nodes, item.children, json);
    }
}

export function separateNodesFromRelations(elements: DBItem[], nodes: DBItem[], relations: DBItem[]) {
    for (const element of elements) {
        if (Array.isArray(element)) {
            for (const child of element) {
                child.isUsed = false;
            }
            separateNodesFromRelations(element, nodes, relations);
            continue;
        }
        if (element.instance === "Relationship") {
            let relation = element as any;
            if (relations.some(r => r.elementId === relation.elementId)) continue;
            relations.push(relation);
            continue;
        }
        if (element.instance === "Node") {
            let node = element as any;
            if (nodes.some(n => n.elementId === node.elementId)) continue;
            nodes.push(node);
            continue;
        }
    }
}